/** Shared, stable hover treatment for Portal navigation and segmented tabs. */
export const PORTAL_TAB_INTERACTION_CLASS_NAME =
  'transition-[background-color,box-shadow,color,transform] duration-200 hover:bg-wash-coral hover:text-ink hover:ring-2 hover:ring-inset hover:ring-brand-coral/50 motion-reduce:transition-none';
